<template>
  <b-row>
    <b-col cols="12">
      <campaign-new-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import CampaignNewForm from './CampaignNewForm.vue'

export default {
  components: {
    BRow,
    BCol,
    CampaignNewForm,
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
